/*
* mutations
* */
import storage from './storage'

export default {
  login (state) { // 设置登录信息
    state.login = true
    storage.setSession('login', true)
  },
  logout (state) { // 注销
    state.login = false
    state.token = null
    storage.clearSession()
  },
  token (state, token) {
    state.token = token
    storage.setSession('token', token)
  },
  userInfo (state, info) {
    state.userInfo = info
    storage.setItem('userInfo', info)
  },
  menu (state, m) {
    state.menu = m
    storage.setItem('menu', m)
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js